module.exports = __webpack_public_path__ + "img/dmart.f9fe3889.svg";